module.exports = __webpack_public_path__ + "img/order_wallet.f26c8bc8.png";